function Header(){
    return(
        <h1>Enamel Pin Collection</h1>
    )
}

export default Header;